import base from './base/index' // 接口域名列表
import axios from '../utils/http' // 导入http中创建的axios实例
import utils from '../utils'
/**
 * 电力运维
 */
const electricOperations = {
  listElectricOperationsWorkBasesOfIJoined(companyId) {
    return axios.post(
      '/api/listElectricOperationsWorkBasesOfIJoined',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  listElectricOperationsWorkBases(companyId) {
    return axios.post(
      base.electricOperations.listElectricOperationsWorkBases,
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addElectricOperationsWorkBase(
    companyId,
    name,
    address,
    addressDetail,
    addressLongitude,
    addressLatitude,
    managerUserId
  ) {
    return axios.post(
      base.electricOperations.addElectricOperationsWorkBase,
      utils.postParamsArrayToJsonString({
        companyId,
        name,
        address,
        addressDetail,
        addressLongitude,
        addressLatitude,
        managerUserId,
      })
    )
  },
  deleteElectricOperationsWorkBase(id) {
    return axios.post(
      base.electricOperations.deleteElectricOperationsWorkBase,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  modifyElectricOperationsWorkBase(
    id,
    name,
    address,
    addressDetail,
    addressLongitude,
    addressLatitude,
    managerUserId
  ) {
    return axios.post(
      base.electricOperations.modifyElectricOperationsWorkBase,
      utils.postParamsArrayToJsonString({
        id,
        name,
        address,
        addressDetail,
        addressLongitude,
        addressLatitude,
        managerUserId,
      })
    )
  },
  addElectricOperationsWorkBaseMembers(id, membersId) {
    return axios.post(
      base.electricOperations.addElectricOperationsWorkBaseMembers,
      utils.postParamsArrayToJsonString({ id, membersId })
    )
  },
  removeElectricOperationsWorkBaseMembers(id, membersId) {
    return axios.post(
      base.electricOperations.removeElectricOperationsWorkBaseMembers,
      utils.postParamsArrayToJsonString({ id, membersId })
    )
  },
  listElectricOperationsWorkBaseMembers(id) {
    return axios.post(
      base.electricOperations.listElectricOperationsWorkBaseMembers,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  listElectricOperationsWorkOrdersForServiceProvider(
    companyId,
    types,
    startTime,
    endTime,
    clientsCompanyId,
    workBases,
    states,
    offset,
    limit
  ) {
    return axios.post(
      base.electricOperations
        .listElectricOperationsWorkOrdersForServiceProvider,
      utils.postParamsArrayToJsonString({
        companyId,
        types,
        startTime,
        endTime,
        clientsCompanyId,
        workBases,
        states,
        offset,
        limit,
      })
    )

    // return utils.simulateReslut([{ id: '121', name: '工单名称', clientCompanyId: '121', clientCompanyName: '客户公司', contractId: '121', contractName: '合同名称', type: 1, startTime: '2021-08-16 16:21:00', endTime: '2021-08-16 16:21:00', planId: '121', planName: '计划名称', clientEventRecordId: null, describe: '计划描述', requireMaintainEquipment: [{ id: '1', name: '1' }], attachments: [{ id: '1', fileName: '1.doc' }], creatorUserId: 11, creatorNickname: '测试用户', creatingTime: '2021-08-16 16:21:00', mainExecutorUserId: 111, mainExecutorNickname: '执行用户', teamMembers: [{ userId: '1', nickname: '1.doc' }], state: 7, stateChangingTime: '2021-08-16 16:21:00', score: 5, scoringTime: '2021-08-16 16:21:00', reportFileResourceId: '56456', clientSignatureFileResourceId: '111', workBaseId: 11, workBaseName: '基地站' }])
  },
  listElectricOperationsWorkOrdersForClient(
    companyId,
    types,
    startTime,
    endTime,
    serviceProvidersCompanyId,
    states,
    offset,
    limit
  ) {
    return axios.post(
      base.electricOperations.listElectricOperationsWorkOrdersForClient,
      utils.postParamsArrayToJsonString({
        companyId,
        types,
        startTime,
        endTime,
        serviceProvidersCompanyId,
        states,
        offset,
        limit,
      })
    )

    // return utils.simulateReslut([{ id: '121', name: '工单名称', clientCompanyId: '121', clientCompanyName: '客户公司', contractId: '121', contractName: '合同名称', type: 1, startTime: '2021-08-16 16:21:00', endTime: '2021-08-16 16:21:00', planId: '121', planName: '计划名称', clientEventRecordId: null, describe: '计划描述', requireMaintainEquipment: [{ id: '1', name: '1' }], attachments: [{ id: '1', fileName: '1.doc' }], creatorUserId: 11, creatorNickname: '测试用户', creatingTime: '2021-08-16 16:21:00', mainExecutorUserId: 111, mainExecutorNickname: '执行用户', teamMembers: [{ userId: '1', nickname: '1.doc' }], state: 7, stateChangingTime: '2021-08-16 16:21:00', score: 5, scoringTime: '2021-08-16 16:21:00', reportFileResourceId: '56456', clientSignatureFileResourceId: '111', workBaseId: 11, workBaseName: '基地站' }])
  },

  listClientsForElectricOperationsCompany(companyId, startTime, endTime) {
    return axios.post(
      base.electricOperations.listClientsForElectricOperationsCompany,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    )
  },
  listElectricOperationsCompaniesForClient(companyId, startTime, endTime) {
    return axios.post(
      base.electricOperations.listElectricOperationsCompaniesForClient,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    )
  },
  scoreElectricOperationsWorkOrder(id, score) {
    return axios.post(
      base.electricOperations.scoreElectricOperationsWorkOrder,
      utils.postParamsArrayToJsonString({ id, score })
    )
  },
  // 合同
  listElectricOperationsContractForServiceProvider(
    companyId,
    startTime,
    endTime,
    clientsCompanyId,
    status
  ) {
    return axios.post(
      base.electricOperations.listElectricOperationsContractForServiceProvider,
      utils.postParamsArrayToJsonString({
        companyId,
        startTime,
        endTime,
        clientsCompanyId,
        status,
      })
    )
  },
  // 计划
  updateWorkBaseOfPlan (params) {
    return axios.post(
      '/api/updateWorkBaseOfPlan',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  addElectricOperationsPlanByContractServiceItem(params) {
    return axios.post(
      base.electricOperations.addElectricOperationsPlanByContractServiceItem,
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  addElectricOperationsPlan(
    companyId,
    name,
    contractId,
    type,
    startTime,
    endTime,
    describe
  ) {
    return axios.post(
      base.electricOperations.addElectricOperationsPlan,
      utils.postParamsArrayToJsonString({
        companyId,
        name,
        contractId,
        type,
        startTime,
        endTime,
        describe,
      })
    )
  },
  listElectricOperationsPlans(
    companyId,
    clientsCompanyId,
    currentPage,
    offset,
    limit
  ) {
    return axios.post(
      base.electricOperations.listElectricOperationsPlans,
      utils.postParamsArrayToJsonString({
        companyId,
        clientsCompanyId,
        currentPage,
        offset,
        limit,
      })
    )
  },
  listElectricOperationsPlansInPage(
    companyId,
    clientsCompanyId,
    startTime,
    endTime,
    id,
    status,
    currentPage,
    pageSize,
    timeType
  ) {
    return axios.post(
      base.electricOperations.listElectricOperationsPlansInPage,
      utils.postParamsArrayToJsonString({
        companyId,
        clientsCompanyId,
        startTime,
        endTime,
        status,
        currentPage,
        pageSize,
        timeType,
      })
    )
  },
  modifyElectricOperationsPlan(id, startTime, endTime, describe) {
    return axios.post(
      base.electricOperations.modifyElectricOperationsPlan,
      utils.postParamsArrayToJsonString({ id, startTime, endTime, describe })
    )
  },
  cancelElectricOperationsPlan(id) {
    return axios.post(
      base.electricOperations.cancelElectricOperationsPlan,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  listElectricOperationsPlansByWorkOrder(ids) {
    return axios.post(
      base.electricOperations.listElectricOperationsPlansByWorkOrder,
      utils.postParamsArrayToJsonString({ ids })
    )
  },
  listElectricOperationsWorkOrderStateChangingHistory(workOrderId) {
    return axios.post(
      base.electricOperations
        .listElectricOperationsWorkOrderStateChangingHistory,
      utils.postParamsArrayToJsonString({ workOrderId })
    )
  },
  // 工单
  listElectricOperationsWorkOrdersByPlan (ids) {
    return axios.post('/api/listElectricOperationsWorkOrdersByPlan', utils.postParamsArrayToJsonString({ ids }))
  },
  listElectricOperationsWorkOrdersForServiceProviderInPage(
    id,
    companyId,
    types,
    startTime,
    endTime,
    clientsCompanyId,
    workBases,
    states,
    currentPage,
    pageSize
  ) {
    return axios.post(
      base.electricOperations
        .listElectricOperationsWorkOrdersForServiceProviderInPage,
      utils.postParamsArrayToJsonString({
        id,
        companyId,
        types,
        startTime,
        endTime,
        clientsCompanyId,
        workBases,
        states,
        currentPage,
        pageSize,
      })
    )
  },
  getElectricOperationsContractInfo(ids) {
    return axios.post(
      base.electricOperations.getElectricOperationsContractInfo,
      utils.postParamsArrayToJsonString({ ids })
    )
  },
  addElectricOperationsWorkOrder(params) {
    return axios.post(
      base.electricOperations.addElectricOperationsWorkOrder,
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  listElectricOperationsWorkOrdersByPlanInPage(
    companyId,
    type,
    startTime,
    endTime,
    clientsCompanyId,
    workBases,
    status,
    currentPage,
    pageSize
  ) {
    return axios.post(
      base.electricOperations.listElectricOperationsWorkOrdersByPlanInPage,
      utils.postParamsArrayToJsonString({
        companyId,
        type,
        startTime,
        endTime,
        clientsCompanyId,
        workBases,
        status,
        currentPage,
        pageSize,
      })
    )
  },
  listElectricOperationsWorkOrderDispatchingPriorityRegulation(
    companyId,
    clientsCompanyId
  ) {
    return axios.post(
      base.electricOperations
        .listElectricOperationsWorkOrderDispatchingPriorityRegulation,
      utils.postParamsArrayToJsonString({ companyId, clientsCompanyId })
    )
  },
  changeElectricOperationsWorkOrderState(id, state, remark) {
    return axios.post(
      base.electricOperations.changeElectricOperationsWorkOrderState,
      utils.postParamsArrayToJsonString({ id, state, remark })
    )
  },
  setElectricOperationsWorkOrderToWorkBase(id, workBaseId, remark) {
    return axios.post(
      base.electricOperations.setElectricOperationsWorkOrderToWorkBase,
      utils.postParamsArrayToJsonString({ id, workBaseId, remark })
    )
  },
  setElectricOperationsWorkOrderExecutor(
    id,
    mainExecutor,
    teamMembers,
    remark
  ) {
    return axios.post(
      base.electricOperations.setElectricOperationsWorkOrderExecutor,
      utils.postParamsArrayToJsonString({
        id,
        mainExecutor,
        teamMembers,
        remark,
      })
    )
  },
  getElectricOperationsWorkOrderReportData(id) {
    return axios.post(
      base.electricOperations.getElectricOperationsWorkOrderReportData,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  lookupElectricOperationsWorkOrderDataDict(orderType) {
    return axios.post(
      base.electricOperations.lookupElectricOperationsWorkOrderDataDict,
      utils.postParamsArrayToJsonString({ orderType })
    )
  },
  getOperationsMeasureInfo(companyId, status) {
    return axios.post(
      base.electricOperations.getOperationsMeasureInfo,
      utils.postParamsArrayToJsonString({ companyId, status })
    )
  },
  getEquipmentMaintenanceHistory(measureId, startTime, endTime) {
    return axios.post(
      base.electricOperations.getEquipmentMaintenanceHistory,
      utils.postParamsArrayToJsonString({ measureId, startTime, endTime })
    )
  },
  listManageWorkBaseInfo(userId) {
    return axios.post(
      base.electricOperations.listManageWorkBaseInfo,
      utils.postParamsArrayToJsonString({ userId })
    )
  },
  // 调度人员查询工单
  listWorkOrderProfileForCommander(params) {
    return axios.post(
      '/api/listWorkOrderProfileForCommander',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  // 基地站站长查询工单概要
  listWorkOrderProfileForStationMaster(params) {
    return axios.post(
      '/api/listWorkOrderProfileForStationMaster',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  // 物品物件模板组
  getArticleTemplateGroups() {
    return axios.post('/api/getArticleTemplateGroups')
  },
  addArticleTemplateGroup(params) {
    return axios.post(
      '/api/addArticleTemplateGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyArticleTemplateGroup(params) {
    return axios.post(
      '/api/modifyArticleTemplateGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteArticleTemplateGroup(id) {
    return axios.post(
      '/api/deleteArticleTemplateGroup',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 物品物件模板
  getArticleTemplates() {
    return axios.post('/api/getArticleTemplates')
  },
  addArticleTemplate(params) {
    return axios.post(
      '/api/addArticleTemplate',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyArticleTemplate(params) {
    return axios.post(
      '/api/modifyArticleTemplate',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteArticleTemplate(id) {
    return axios.post(
      '/api/deleteArticleTemplate',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 属性模板参数项
  getArticlePropertyTemplateItems(templateId) {
    return axios.post(
      '/api/getArticlePropertyTemplateItems',
      utils.postParamsArrayToJsonString({ templateId })
    )
  },
  addArticlePropertyTemplateItem(params) {
    return axios.post(
      '/api/addArticlePropertyTemplateItem',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyArticlePropertyTemplateItem(params) {
    return axios.post(
      '/api/modifyArticlePropertyTemplateItem',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteArticlePropertyTemplateItem(id) {
    return axios.post(
      '/api/deleteArticlePropertyTemplateItem',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 查询所有设备型号
  getAllDeviceModel() {
    return axios.post('/api/getAllDeviceModel')
  },

  // 备品备件组
  getSparepartGroup(companyId) {
    return axios.post(
      '/api/getSparepartGroup',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addSparepartGroup(params) {
    return axios.post(
      '/api/addSparepartGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifySparepartGroup(params) {
    return axios.post(
      '/api/modifySparepartGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteSparepartGroup(id) {
    return axios.post(
      '/api/deleteSparepartGroup',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 备品备件属性
  getPointedSparepartProperty(params) {
    return axios.post(
      '/api/getPointedSparepartProperty',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  getSparepartProperty(sparepartId) {
    return axios.post(
      '/api/getSparepartProperty',
      utils.postParamsArrayToJsonString({ sparepartId })
    )
  },
  getCompleteSparepartProperty(sparepartId) {
    return axios.post(
      '/api/getCompleteSparepartProperty',
      utils.postParamsArrayToJsonString({ sparepartId })
    )
  },
  batchModifySparepartPropertyValue(sparepartId, valueListStr) {
    return axios.post(
      '/api/batchModifySparepartPropertyValue',
      utils.postParamsArrayToJsonString({ sparepartId, valueListStr })
    )
  },

  // 备品备件
  getSparepartInfos(groupId) {
    return axios.post(
      '/api/getSparepartInfos',
      utils.postParamsArrayToJsonString({ groupId })
    )
  },
  getSparepartProfiles(groupId) {
    return axios.post(
      '/api/getSparepartProfiles',
      utils.postParamsArrayToJsonString({ groupId })
    )
  },
  getSpareparts(groupsId) {
    return axios.post(
      '/api/getSpareparts',
      utils.postParamsArrayToJsonString({ groupsId })
    )
  },
  addSparepart(params) {
    return axios.post(
      '/api/addSparepart',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifySparepart(params) {
    return axios.post(
      '/api/modifySparepart',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteSparepart(id) {
    return axios.post(
      '/api/deleteSparepart',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 工器具组
  getToolGroups(companyId) {
    return axios.post(
      '/api/getToolGroups',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addToolGroup(params) {
    return axios.post(
      '/api/addToolGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyToolGroup(params) {
    return axios.post(
      '/api/modifyToolGroup',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteToolGroup(id) {
    return axios.post(
      '/api/deleteToolGroup',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 工器具属性
  getPointedToolProperty(params) {
    return axios.post(
      '/api/getPointedToolProperty',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  getToolProperty(toolId) {
    return axios.post(
      '/api/getToolProperty',
      utils.postParamsArrayToJsonString({ toolId })
    )
  },
  getCompleteToolProperty(toolId) {
    return axios.post(
      '/api/getCompleteToolProperty',
      utils.postParamsArrayToJsonString({ toolId })
    )
  },
  batchModifyToolPropertyValue(toolId, valueListStr) {
    return axios.post(
      '/api/batchModifyToolPropertyValue',
      utils.postParamsArrayToJsonString({ toolId, valueListStr })
    )
  },

  // 工器具
  getTools(groupsId) {
    return axios.post(
      '/api/getTools',
      utils.postParamsArrayToJsonString({ groupsId })
    )
  },
  getToolInfos(groupId) {
    return axios.post(
      '/api/getToolInfos',
      utils.postParamsArrayToJsonString({ groupId })
    )
  },
  addTool(params) {
    return axios.post(
      '/api/addTool',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyTool(params) {
    return axios.post(
      '/api/modifyTool',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteTool(id) {
    return axios.post(
      '/api/deleteTool',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 服务区域
  listServiceRegionByCompanyId(companyId) {
    return axios.post(
      '/api/listServiceRegionByCompanyId',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  selectServiceRegion(id) {
    return axios.post(
      '/api/selectServiceRegion',
      utils.postParamsArrayToJsonString({ id })
    )
  },
  addServiceRegion(params) {
    return axios.post(
      '/api/addServiceRegion',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifyServiceRegion(params) {
    return axios.post(
      '/api/modifyServiceRegion',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteServiceRegion(id) {
    return axios.post(
      '/api/deleteServiceRegion',
      utils.postParamsArrayToJsonString({ id })
    )
  },

  // 服务规格
  getSpecificationConfigInfo(companyId) {
    return axios.post(
      '/api/getSpecificationConfigInfo',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addServiceSpecification(params) {
    return axios.post(
      '/api/addServiceSpecification',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  modifySpecificationConfig(params) {
    return axios.post(
      '/api/modifySpecificationConfig',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteServiceSpecification(params) {
    return axios.post(
      '/api/deleteServiceSpecification',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  // 合同项目
  getContractProjectByContractId(contactId) {
    return axios.post(
      '/api/getContractProjectByContractId',
      utils.postParamsArrayToJsonString({ contactId })
    )
  },
  getContractProjectByIds(projectIds) {
    return axios.post(
      '/api/getContractProjectByIds',
      utils.postParamsArrayToJsonString({ projectIds })
    )
  },
  getContractProjectByNumbers(numbers) {
    return axios.post(
      '/api/getContractProjectByNumbers',
      utils.postParamsArrayToJsonString({ numbers })
    )
  },
  addContractProject(params) {
    return axios.post(
      '/api/addContractProject',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  updateContractProjectName(params) {
    return axios.post(
      '/api/updateContractProjectName',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteContractProjects(projectIds) {
    return axios.post(
      '/api/deleteContractProjects',
      utils.postParamsArrayToJsonString({ projectIds })
    )
  },
  // 知识库
  getKnowledgeBase(companyId) {
    return axios.post(
      base.electricOperations.getKnowledgeBase,
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addKnowledgeBase(companyId, content, title) {
    return axios.post(
      base.electricOperations.addKnowledgeBase,
      utils.postParamsArrayToJsonString({ companyId, content, title })
    )
  },
  deleteKnowledgeBase(id) {
    return axios.post(
      base.electricOperations.deleteKnowledgeBase,
      utils.postParamsArrayToJsonString({ id })
    )
  },
  updateKnowledgeBase(companyId, content, id, title) {
    return axios.post(
      base.electricOperations.updateKnowledgeBase,
      utils.postParamsArrayToJsonString({ companyId, content, id, title })
    )
  },

  // 查询维保视图节点信息
  getMOViewTreeNodes(companyId) {
    return axios.post(
      '/api/getMOViewTreeNodes',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },

  getMOViewTreeNodes(companyId) {
    return axios.post(
      base.electricOperations.getMOViewTreeNodes,
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  getElectricOperationsWorkOrder(workorderId) {
    return axios.post(
      base.electricOperations.getElectricOperationsWorkOrder,
      utils.postParamsArrayToJsonString({ workorderId })
    )
  },
  listProjectVOInfoForClient(
    companyId,
    currentPage,
    endTime,
    pageSize,
    startTime,
    status
  ) {
    return axios.post(
      base.electricOperations.listProjectVOInfoForClient,
      utils.postParamsArrayToJsonString({
        companyId,
        currentPage,
        endTime,
        pageSize,
        start: null,
        startTime,
        status,
      })
    )
  },
  getProjectVOListByProjectId(projectId) {
    return axios.post(
      base.electricOperations.getProjectVOListByProjectId,
      utils.postParamsArrayToJsonString({ projectId })
    )
  },
  listWorkOrderPlanInfoInPage(
    companyId,
    currentPage,
    endTime,
    pageSize,
    startTime,
    status
  ) {
    return axios.post(
      base.electricOperations.listWorkOrderPlanInfoInPage,
      utils.postParamsArrayToJsonString({
        companyId,
        currentPage,
        endTime,
        pageSize,
        start: null,
        startTime,
        status,
      })
    )
  },

  listElectricOperationsWorkOrderDispatchingPriorityRegulation(params) {
    return axios.post(
      '/api/listElectricOperationsWorkOrderDispatchingPriorityRegulation',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  setElectricOperationsWorkOrderDispatchingPriorityRegulation(params) {
    return axios.post(
      '/api/setElectricOperationsWorkOrderDispatchingPriorityRegulation',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  getReviewerInfoForCompany(companyId) {
    return axios.post(
      '/api/getReviewerInfoForCompany',
      utils.postParamsArrayToJsonString({ companyId })
    )
  },
  addWorkOrderReviewer(params) {
    return axios.post(
      '/api/addWorkOrderReviewer',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },
  deleteWorkOrderReviewer(params) {
    return axios.post(
      '/api/deleteWorkOrderReviewer',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  statisticPlanCountInMonthForCommander(statisticDate) {
    return axios.post(
      '/api/statisticPlanCountInMonthForCommander',
      utils.postParamsArrayToJsonString({ statisticDate })
    )
  },
  statisticPlanCountInMonthForBaseMaster(statisticDate) {
    return axios.post(
      '/api/statisticPlanCountInMonthForBaseMaster',
      utils.postParamsArrayToJsonString({ statisticDate })
    )
  },
  statisticPlanCountInYearForCommander(statisticDate) {
    return axios.post(
      '/api/statisticPlanCountInYearForCommander',
      utils.postParamsArrayToJsonString({ statisticDate })
    )
  },
  statisticPlanCountInYearForBaseMaster(statisticDate) {
    return axios.post(
      '/api/statisticPlanCountInYearForBaseMaster',
      utils.postParamsArrayToJsonString({ statisticDate })
    )
  },

  getUserLocation(userId) {
    return axios.post(
      '/api/getUserLocation',
      utils.postParamsArrayToJsonString({ userId })
    )
  },

  listElectricOperationsWorkOrdersByPlan(ids) {
    return axios.post(
      base.electricOperations.listElectricOperationsWorkOrdersByPlan,
      utils.postParamsArrayToJsonString({ ids })
    )
  },

  // 设备型号
  getAllDeviceModel () {
    return axios.post(
      '/api/getAllDeviceModel'
    )
  },

  addDeviceModel (params) {
    return axios.post(
      '/api/addDeviceModel',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  modifyDeviceModel (params) {
    return axios.post(
      '/api/modifyDeviceModel',
      utils.postParamsArrayToJsonString({ ...params })
    )
  },

  deleteDeviceModel (modelId) {
    return axios.post(
      '/api/deleteDeviceModel',
      utils.postParamsArrayToJsonString({ modelId })
    )
  },

  
}

export default electricOperations
